import { fromJS } from 'immutable';
import { normalize } from 'normalizr';

import { mapListToRecords, normalizeList } from '@sophocles/entities/entityUtils';
import {
  RelayControllerFirmwareVersion,
  relayControllerFirmwareVersionSchema,
} from '@sophocles/entities/RelayControllerFirmwareVersion/relayControllerFirmwareVersionRecord';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';

/* Receive Actions */
export const RECEIVE_RELAY_CONTROLLER_FIRMWARE_VERSIONS = 'RECEIVE_RELAY_CONTROLLER_FIRMWARE_VERSIONS';
export function receiveRelayControllerFirmwareVersions(json) {
  return {
    type: RECEIVE_RELAY_CONTROLLER_FIRMWARE_VERSIONS,
    relayControllerFirmwareVersions: mapListToRecords(json, RelayControllerFirmwareVersion),
  };
}

/* Request Actions */
// starter request
export const REQUEST_RELAY_CONTROLLER_FIRMWARE_VERSION = 'REQUEST_RELAY_CONTROLLER_FIRMWARE_VERSION';
function requestRelayControllerFirmwareVersion(relayControllerFirmwareVersion_id) {
  return {
    type: REQUEST_RELAY_CONTROLLER_FIRMWARE_VERSION,
    relayControllerFirmwareVersion_id,
  };
}

export const REQUEST_ALL_RELAY_CONTROLLER_FIRMWARE_VERSIONS = 'REQUEST_ALL_RELAY_CONTROLLER_FIRMWARE_VERSIONS';
function requestAllRelayControllerFirmwareVersions() {
  return {
    type: REQUEST_ALL_RELAY_CONTROLLER_FIRMWARE_VERSIONS,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchRelayControllerFirmwareVersion(relayControllerFirmwareVersion_id) {
  return dispatch => {
    dispatch(requestRelayControllerFirmwareVersion(relayControllerFirmwareVersion_id));
    return apiClient
      .get(`/relaycontrollerfirmwareversions/${relayControllerFirmwareVersion_id}/`, { params: { limit: 10000 } })
      .then(checkHttpStatus)
      .then(response =>
        normalizeList(response.data, 'relayControllerFirmwareVersions', relayControllerFirmwareVersionSchema),
      )
      .then(json => dispatch(receiveRelayControllerFirmwareVersions(json.entities.relayControllerFirmwareVersions)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_RELAY_CONTROLLER_FIRMWARE_VERSION)));
  };
}

export function fetchAllRelayControllerFirmwareVersions(filters = {}) {
  return dispatch => {
    dispatch(requestAllRelayControllerFirmwareVersions());
    return apiClient
      .get('/relaycontrollerfirmwareversions/', { params: { limit: 10000, ...filters } })
      .then(checkHttpStatus)
      .then(response =>
        normalizeList(response.data.results, 'relayControllerFirmwareVersions', relayControllerFirmwareVersionSchema),
      )
      .then(json => dispatch(receiveRelayControllerFirmwareVersions(json.entities.relayControllerFirmwareVersions)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_RELAY_CONTROLLER_FIRMWARE_VERSION)));
  };
}

export function rawFetchAllRelayControllerFirmwareVersions() {
  return dispatch => {
    dispatch(requestAllRelayControllerFirmwareVersions());
    return apiClient
      .get('/relaycontrollerfirmwareversions/', { params: { limit: 10000 } })
      .then(checkHttpStatus)
      .then(response => fromJS(response.data.results))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_RELAY_CONTROLLER_FIRMWARE_VERSION)));
  };
}

/* Edit Actions */
export const EDIT_RELAY_CONTROLLER_FIRMWARE_VERSION = 'EDIT_RELAY_CONTROLLER_FIRMWARE_VERSION';
export function editRelayControllerFirmwareVersion(relayControllerFirmwareVersion_id) {
  return {
    type: EDIT_RELAY_CONTROLLER_FIRMWARE_VERSION,
    relayControllerFirmwareVersion: relayControllerFirmwareVersion_id,
  };
}

export function patchRelayControllerFirmwareVersion(relayControllerFirmwareVersion_id, values) {
  return dispatch => {
    dispatch(editRelayControllerFirmwareVersion(relayControllerFirmwareVersion_id));

    return apiClient
      .patch(`/relaycontrollerfirmwareversions/${relayControllerFirmwareVersion_id}/`, values, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(checkHttpStatus)
      .then(response => normalize(response.data, relayControllerFirmwareVersionSchema))
      .then(json => dispatch(receiveRelayControllerFirmwareVersions(json.entities.relayControllerFirmwareVersions)))
      .catch(error => dispatch(genericErrorAction(error, EDIT_RELAY_CONTROLLER_FIRMWARE_VERSION)));
  };
}

/* Create Actions */
export const CREATE_RELAY_CONTROLLER_FIRMWARE_VERSION = 'CREATE_RELAY_CONTROLLER_FIRMWARE_VERSION';
function sayCreateRelayControllerFirmwareVersion(values) {
  return {
    type: CREATE_RELAY_CONTROLLER_FIRMWARE_VERSION,
    values: values,
  };
}

export function createRelayControllerFirmwareVersion(values) {
  return dispatch => {
    dispatch(sayCreateRelayControllerFirmwareVersion(values));
    return apiClient
      .post(`/relaycontrollerfirmwareversions/`, values, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(checkHttpStatus)
      .then(response => normalize(response.data, relayControllerFirmwareVersionSchema))
      .then(json => dispatch(receiveRelayControllerFirmwareVersions(json.entities.relayControllerFirmwareVersions)))
      .catch(error => dispatch(genericErrorAction(error, CREATE_RELAY_CONTROLLER_FIRMWARE_VERSION)));
  };
}

/* Delete Actions */
export const DELETE_RELAY_CONTROLLER_FIRMWARE_VERSION = 'DELETE_RELAY_CONTROLLER_FIRMWARE_VERSION';
function sayDeleteRelayControllerFirmwareVersion(relayControllerFirmwareVersion_id) {
  return {
    type: DELETE_RELAY_CONTROLLER_FIRMWARE_VERSION,
    relayControllerFirmwareVersion: relayControllerFirmwareVersion_id,
  };
}

export function deleteRelayControllerFirmwareVersion(relayControllerFirmwareVersion_id) {
  return dispatch =>
    apiClient
      .delete(`/relaycontrollerfirmwareversions/${relayControllerFirmwareVersion_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteRelayControllerFirmwareVersion(relayControllerFirmwareVersion_id)))
      .catch(error => dispatch(genericErrorAction(error, DELETE_RELAY_CONTROLLER_FIRMWARE_VERSION)));
}
